import { Badge } from "@mantine/core";
import {
  IconCircleCheck,
  IconClock,
  IconMailFast,
  IconXboxXFilled,
} from "@tabler/icons-react";

function RegistrationStatusBadge({ status }) {
  const statusColors = {
    approved: "green",
    pending: "yellow",
    rejected: "red",
    invoiced: "orange",
  };

  const leftSection = {
    approved: <IconCircleCheck size={12} />,
    pending: <IconClock size={12} />,
    rejected: <IconXboxXFilled size={12} />,
    invoiced: <IconMailFast size={12} />,
  };

  return (
    <Badge
      color={statusColors[status]}
      style={{ textTransform: "capitalize" }}
      leftSection={leftSection[status]}
      variant="light"
    >
      {status}
    </Badge>
  );
}

export default RegistrationStatusBadge;
